export default __webpack_public_path__ + "static/media/coins.985572b0.png";